import { type BoPage, page, withEshop } from "./model";

/** Données, e-shop, compte et réglages. */
export const APP_PAGES: BoPage[] = [
  // Données
  page(
    "artwork",
    "Tableau des œuvres",
    "/dashboard/artwork",
    "palette",
    "data",
  ),
  page(
    "multipleprint",
    "Tableau des multiples",
    "/dashboard/multipleprint",
    "layers",
    "data",
  ),
  page(
    "exhibition",
    "Tableau des expositions",
    "/dashboard/exhibition",
    "landmark",
    "data",
  ),
  page(
    "bibliography",
    "Tableau de la bibliographie",
    "/dashboard/bibliography",
    "book",
    "data",
  ),
  page(
    "auction",
    "Tableau des ventes publiques",
    "/dashboard/auction",
    "gavel",
    "data",
  ),
  page("author", "Tableau des auteurs", "/dashboard/author", "user", "data"),
  page(
    "collector",
    "Tableau des collectionneurs",
    "/dashboard/collector",
    "user",
    "data",
  ),
  page(
    "writing",
    "Tableau des écrits",
    "/dashboard/writing",
    "pen-line",
    "data",
  ),
  page(
    "photography",
    "Tableau des photographies",
    "/dashboard/photography",
    "camera",
    "data",
    (ctx) => ctx.photoModule,
  ),
  page(
    "document",
    "Tableau des documents",
    "/dashboard/document",
    "file-text",
    "data",
  ),
  page(
    "audiovisual",
    "Tableau des audiovisuels",
    "/dashboard/audiovisual",
    "film",
    "data",
  ),
  page("notes", "Mes notes", "/dashboard/notes", "file-text", "data"),
  page("import", "Importer des données", "/import", "upload", "data"),
  page("trash", "Corbeille", "/trash", "trash", "data"),

  // E-shop
  page(
    "eshopOrders",
    "Ventes de l’e-shop",
    "/e-shop?view=orders",
    "shopping-cart",
    "eshop",
    withEshop,
  ),
  page(
    "eshopCustomers",
    "Clients de l’e-shop",
    "/e-shop?view=customers",
    "user",
    "eshop",
    withEshop,
  ),

  // Compte et réglages
  page(
    "mainAccount",
    "Compte principal",
    "/compte-principal",
    "user",
    "account",
  ),
  page("settings", "Mes réglages", "/settings", "settings", "account"),
];
